export const TOAST_DURATION_MS = 5000;

export const TOAST_TYPES = Object.freeze({
	ERROR: 'error',
	SUCCESS: 'success',
});

export const TOAST_MESSAGES = Object.freeze({
	PASSWORD_CHANGED: 'Password changed',
});
